import React, { useEffect, useState, useRef } from "react";
import { ChevronLeft, ChevronRight, Phone } from "lucide-react";
import { HERO_SLIDES, BRAND } from "../mock";

export default function Hero() {
  const [i, setI] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % HERO_SLIDES.length), 6500);
    return () => clearInterval(id);
  }, []);

  const slide = HERO_SLIDES[i];
  const next = () => setI((p) => (p + 1) % HERO_SLIDES.length);
  const prev = () => setI((p) => (p - 1 + HERO_SLIDES.length) % HERO_SLIDES.length);

  return (
    <section ref={ref} className="relative h-[78vh] min-h-[560px] overflow-hidden bg-[#0a0a0a]">
      {HERO_SLIDES.map((s, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            idx === i ? "opacity-100" : "opacity-0"
          }`}
          style={{
            backgroundImage: `linear-gradient(rgba(10,10,10,0.55), rgba(10,10,10,0.35)), url('${s.img}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      ))}

      <div className="relative h-full max-w-7xl mx-auto px-6 flex items-center">
        <div key={i} className="max-w-3xl">
          <span className="slide-up inline-block bg-[#f5a623] text-[#0a0a0a] px-3 py-1.5 text-[11px] font-bold tracking-[0.18em] mb-6">
            {slide.eyebrow}
          </span>
          <h1 className="slide-up slide-up-1 display-font text-white text-5xl md:text-7xl font-bold leading-[0.95] mb-3">
            {slide.title}
          </h1>
          <h2 className="slide-up slide-up-2 display-font text-[#f5a623] text-2xl md:text-4xl font-medium mb-6">
            {slide.subtitle}
          </h2>
          <p className="slide-up slide-up-3 text-white/85 text-base md:text-lg max-w-xl mb-8 leading-relaxed">
            {slide.text}
          </p>
          <div className="slide-up slide-up-3 flex flex-wrap items-center gap-4">
            <a
              href="#services"
              className="btn-amber px-7 py-3.5 font-bold uppercase tracking-wider text-sm"
            >
              Explore Capabilities
            </a>
            <a
              href={BRAND.phoneHref}
              className="inline-flex items-center gap-2 border-2 border-white text-white px-7 py-3.5 font-bold uppercase tracking-wider text-sm hover:bg-white hover:text-[#0a0a0a] transition-colors"
            >
              <Phone className="w-4 h-4" /> Call Us
            </a>
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
        {HERO_SLIDES.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setI(idx)}
            className={`hero-dot ${idx === i ? "active" : ""}`}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={prev}
        aria-label="Previous slide"
        className="hidden md:flex absolute left-5 top-1/2 -translate-y-1/2 w-12 h-12 items-center justify-center border border-white/40 text-white hover:bg-[#f5a623] hover:border-[#f5a623] hover:text-[#0a0a0a] transition-colors"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <button
        onClick={next}
        aria-label="Next slide"
        className="hidden md:flex absolute right-5 top-1/2 -translate-y-1/2 w-12 h-12 items-center justify-center border border-white/40 text-white hover:bg-[#f5a623] hover:border-[#f5a623] hover:text-[#0a0a0a] transition-colors"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </section>
  );
}
